import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  body: {
    paddingTop: '60px'
  },
  tabs: {
    marginTop: '30px'
  },
  carousel: {
    marginTop: '30px',
    justifyContent: 'center'
  }
});
